import { action } from '@ember/object';
import { alias } from '@ember/object/computed';
import Controller, { inject as controller } from '@ember/controller';

export default class ListController extends Controller {
  @controller('data-index.type.list.index') listIndex;

  @alias('listIndex.search') search;

  @alias('listIndex.page') page;

  type = null;
  paginationTotal = null;
  searchTotals = null;
  searchInput = '';
  items = null;
  itemsPerPage = 50;

  @action
  clearSearch() {
    this.setProperties({
      search: '',
      searchInput: '',
      page: 1,
    });
  }

  @action
  onSearch(e) {
    e.preventDefault();
    this.setProperties({
      search: this.searchInput,
      page: 1,
    });
  }
}
